import BaseViewModel from './BaseViewModel';

class PlaceholderViewModel extends BaseViewModel {}

export default PlaceholderViewModel;
